import axios from "axios";

// Same-origin API base — see /app/frontend/src/lib/api.js for the rationale.
// Emergent's ingress routes /api/* to the backend on every domain, so calling
// the same origin we're being served from removes CORS entirely.
const BACKEND_URL =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true, // send session_token cookie on every request
});

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function buildRedirectUrl() {
  return window.location.origin + "/admin";
}

export const adminApi = {
  // Auth ---------------------------------------------------------------
  loginUrl() {
    return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(buildRedirectUrl())}`;
  },
  exchangeSession(session_id) {
    return client.post("/auth/session", { session_id }).then((r) => r.data);
  },
  me() {
    return client.get("/auth/me").then((r) => r.data);
  },
  logout() {
    return client.post("/auth/logout").then((r) => r.data);
  },

  // Admin --------------------------------------------------------------
  summary(params) {
    return client.get("/admin/summary", { params }).then((r) => r.data);
  },
  funnel(params) {
    return client.get("/admin/funnel", { params }).then((r) => r.data);
  },
  wizardFunnel(params) {
    return client.get("/admin/wizard-funnel", { params }).then((r) => r.data);
  },
  byState(params) {
    return client.get("/admin/by-state", { params }).then((r) => r.data);
  },
  documents(params) {
    return client.get("/admin/documents", { params }).then((r) => r.data);
  },
  payments(params) {
    return client.get("/admin/payments", { params }).then((r) => r.data);
  },
  leads(params) {
    return client.get("/admin/leads", { params }).then((r) => r.data);
  },
  valuationLeads(params) {
    return client.get("/admin/valuation-leads", { params }).then((r) => r.data);
  },
  errors(params) {
    return client.get("/admin/errors", { params }).then((r) => r.data);
  },

  // ---- Contact inbox ----
  contactMessages(params) {
    return client.get("/admin/contact-messages", { params }).then((r) => r.data);
  },
  replyContactMessage(id, body) {
    return client.post(`/admin/contact-messages/${id}/reply`, { body }).then((r) => r.data);
  },
  setContactMessageStatus(id, status) {
    return client.patch(`/admin/contact-messages/${id}`, { status }).then((r) => r.data);
  },
};
